import React, {useState, useRef, useEffect} from 'react'
import { Container } from 'react-bootstrap'
import Carousel from 'components/dashboard/dashcomp/carousel'
import FlashSaleJson from 'json/dashboard/flash_sale'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
// import {Link} from 'react-router-dom'
import './style.css'

export default function FlashSale() {
    const [timerDays, setTimerDays] = useState('0')
    const [timerHouse, setTimerHouse] = useState('0')
    const [timerMinuts, setTimerMinuts] = useState('0')
    const [timerSecons, setTimerSecons] = useState('0')

    let interval = useRef()

    const startTimer = () => {
        const countDownDate = new Date('september 7, 2021 00:00:00').getTime()

        interval = setInterval(() => {
            const now = new Date().getTime()
            const distance = countDownDate - now;

            const days = Math.floor(distance / (1000 * 60 * 60 * 24))
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)))
            const minuts = Math.floor((distance % (1000 * 60 * 60 )) / (1000 * 60 ))
            const secons = Math.floor((distance % (1000 * 60 )) / 1000)

            if(distance < 0) {
                clearInterval(interval.current)
            } else {
                setTimerDays(days)
                setTimerHouse(hours)
                setTimerMinuts(minuts)
                setTimerSecons(secons)
            }
        }, 1000)
    }

    useEffect(() => {
        startTimer();
    })

    return (
     <>
        <Container className="flashsale">
            <div className="flashsale-judul d-flex justify-content-between">
                <h3>Flash Sale</h3>
                <p>{timerDays}H</p>
                <p>{timerHouse}</p>
                <p>{timerMinuts}</p>
                <p>{timerSecons}</p>
            </div>
            <Slider {...settings}>
                {
                    FlashSaleJson.map((item, i) => {
                        return (
                                        <Carousel key={i}
                                        cCard="flash_sale_produk"
                                        header="Komisi 20 rb"
                                        src={item.src} alt={item.alt}
                                        text={item.text} potongan={item.price}
                                        progress="progress"
                                        price="Rp. 100.000" terjual="10 Terjual"
                                        stok="Sisa Stok 21"
                                        />
                        )
                    })
                }
            </Slider>
        </Container>
        <Container>
            <div className="promo"> 
                 <img src="asset/dashboard/flash_sale/promo_flash.png" alt="promo" />
            </div>
        </Container>
    </>
    )
}

let settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
